import React from 'react'
import {TextField} from '@mui/material'
import type {TextFieldProps} from '@mui/material'
import type {FieldRenderProps} from 'react-final-form'

type AdapterProps<Value> = FieldRenderProps<Value, HTMLInputElement | HTMLTextAreaElement> &
  Omit<TextFieldProps, 'value' | 'onChange'> & {showError?: boolean}

function RffTextFieldAdapter<Value>({input, meta, showError = false, ...rest}: AdapterProps<Value>) {
  const error: unknown = meta.error
  return (
    <TextField
      {...input}
      {...rest}
      onChange={event => input.onChange(event.target.value)}
      error={Boolean((meta.touched || showError) && error)}
      helperText={(meta.touched || showError) && typeof error === 'string' ? error : ''}
    />
  )
}

export default RffTextFieldAdapter
